import { render, staticRenderFns } from "./Tournament2025.vue?vue&type=template&id=3e4a408a&scoped=true"
import script from "./Tournament2025.vue?vue&type=script&lang=js"
export * from "./Tournament2025.vue?vue&type=script&lang=js"
import style0 from "./Tournament2025.vue?vue&type=style&index=0&id=3e4a408a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4a408a",
  null
  
)

export default component.exports